import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Pipe({ name: "safeHtmlContent" })
export class SafeHtmlPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(content: any): any {
    return this.sanitizer.bypassSecurityTrustHtml(content);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/safe-html.pipe.ts